module.exports = __webpack_public_path__ + "static/carpool-gallery-6-6f6d8ed8da5f52f4d9feb16e143ff1ac.jpg";